let mobileSubNav = $(".nav__section__links");
const backBtn = $(".js-back");
const parentLink = $(".nav__section__title");
import CustomEvent from '../utils/events/customEvent';
import scrollLock from "../utils/scroll-lock";

var isMobile =
  navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) ||
  document.body.clientWidth <= 1024;


function init() {
    InitNav();
    InitNavSearch();
}
function InitNav() {
  if (isMobile) {
    $(".nav__section__title").each((index, el) => {
      $(el).attr("tabindex", "-1");
    });
    $("#nav-search-mobile").attr("tabindex", "-1");
    $("#header-search-mobile .btn--search-alt").attr("tabindex", "-1");
  }

  $(".js-menu-btn").on("click", function () {
    $(".js-menu-btn, .js-nav").toggleClass("open");
    $("html").toggleClass("nav-open");
    let w = document.body.clientWidth;
    if ($("html").hasClass("nav-open") && w < 1024) {
      scrollLock.enable();
      $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "0");
      $(".nav__section__title").attr("tabindex", 0);
      $("main, footer").hide(0);
      $(".js-search-btn").hide();
      $(".skip-to-main").hide();
    } else {
      if (w < 1024) {
        scrollLock.disable();
        $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
        $("main, footer").show(0);
        $("header, .js-nav").scrollTop(0);
        $(".js-search-btn").show();
        $(".skip-to-main").show();
      }
    }
    if (!$(".js-menu-btn, .js-nav").hasClass("open")) {
      $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
      $(".nav__section__links").removeClass("active");

      $("main, footer a").attr("aria-hidden", false);
      $("main, footer").show(0);

    }
  });

  $(".js-menu-btn").on("keypress", function (e) {
    $("#nav-search-mobile").attr("tabindex", "0");
    $(".nav__section__title").attr("tabindex", 0);
    $("#header-search-mobile .btn--search-alt").attr("tabindex", "0");

    if (e.code === "Enter") {
      $(".js-menu-btn, .js-nav").toggleClass("open");
      $("html").toggleClass("nav-open");
      let w = document.body.clientWidth;
      if ($("html").hasClass("nav-open") && w < 1024) {
        $("main, footer").hide(0);
        $(".js-search-btn").hide();
        $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "0");
        scrollLock.enable();
      } else {
        if (w < 1024) {
          $(".js-search-btn").show();
          scrollLock.disable();
          $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
          $("header, .js-nav").scrollTop(0);
        }
      }
      if (!$(".js-menu-btn, .js-nav").hasClass("open")) {
        $(".nav__section__links").removeClass("active");
        $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
        $("main, footer").show(0);
        if (isMobile) {
          $(".nav__section__title").attr("tabindex", -1);
        }
      } else {
        $(".nav__section__subnav a").each((index, el) => {
          $(el).attr("tabindex", "-1");
        });
        $(".nav__section__title").attr("tabindex", 0);
      }
    }
  });
  backBtn.on("click", function () {
    $(this)
      .closest(".nav__section__links")
      .parent()
      .blur();
    $(this)
      .closest(".nav__section__links")
      .removeClass("active");
    $(".nav__section__subnav a").each((index, el) => {
      $(el).attr("tabindex", "-1");
    });
    $(".nav__section__title").attr('tabindex', 0);
    $("#nav-search-mobile").attr("tabindex", "0");
    $("#header-search-mobile .btn--search-alt").attr("tabindex", "0");
  });

document.addEventListener("keydown", function () {
    if (event.keyCode === 27) {
        $(".nav__section__links").addClass("active");
    }
});

if (isMobile) {
  $(".nav__section__subnav a").each((index, el) => {
    $(el).attr("tabindex", "-1");
  });
}

}

const openMobileSearch = () => {
  $(".js-menu-btn, .js-nav").addClass("open");
  $("html").toggleClass("nav-open");
  $(".nav__section__links").removeClass("active");
  $(".nav__section__subnav a").each((index, el) => {
    $(el).attr("tabindex", "-1");
  });
  $(".nav__section__title").attr("tabindex", 0);
  $("main, footer").hide(0);
  setTimeout(() => {
    const mobileSearch = document.getElementById("nav-search-mobile");
    $("#nav-search-mobile").attr("tabindex", "0");
    $(mobileSearch).focus();
  }, 250);
};


function InitNavSearch() {
  $(".js-search-btn").on("click", (event) => {
    event.preventDefault();
    $(".js-menu-btn, .js-nav").toggleClass("open");

    if (!$(".js-menu-btn, .js-nav").hasClass("open")) {
      $(".nav__section__links").removeClass("active");
      $(".nav__section__subnav a").each((index, el) => {
        $(el).attr("tabindex", "-1");
      });
    } else {
      setTimeout(() => {
        const mobileSearch = document.getElementById("nav-search-mobile");
        $("#nav-search-mobile").attr("tabindex", "0");
        $(mobileSearch).focus();
      }, 250);
    }
  });

  $(".header__search-mobile").on("click", (event) => {
    event.preventDefault();
    $(".js-search-btn").hide();
    openMobileSearch();
  });

  $(".header__search-mobile").on("keydown", (event) => {
    if (event.code === "Enter") {
      $(".js-search-btn").hide();
      openMobileSearch();
    }
  });

  $(".nav__section__title").on("click", function (event) {
    var target = $(event.target);
    let secondNavItem = target.data("nav-name");

    $(".nav__section__links[data-nav-name = " + secondNavItem + "]").addClass(
      "active"
    );

    $("#nav-search-mobile").attr("tabindex", "-1");
    $("#header-search-mobile .btn--search-alt").attr("tabindex", "-1");
    const tabIndexes = $(
      ".nav__section__links[data-nav-name = " + secondNavItem + "]"
    ).find("a");
    $(tabIndexes).each((index, el) => {
      $(el).attr("tabindex", 0);
    });

    if (isMobile) {
      $(".nav__section__title").each((index, el) => {
        $(el).attr("tabindex", "-1");
      });
    }

    $($(tabIndexes).last()).on("keydown", (e) => {
      if (e.code === "Tab") {
        const menuButton = document.querySelector(".js-menu-btn");
        menuButton.focus();

      }
    });
    if (isMobile && !!secondNavItem) {
      event.preventDefault();
    }
    if (target.hasClass("campaign")) {
      // event.preventDefault();
      setTimeout(() => {
        $(".js-menu-btn, .js-nav").removeClass("open");
      }, 1000);
    }
  });

  window.addEventListener('closeNav', (event) => {

    $(".js-menu-btn, .js-nav").removeClass("open");
    $("html").removeClass("nav-open");
    scrollLock.disable();
    if (window.innerWidth < 1024) {

      $("#nav-search-mobile, .btn--search-alt").attr("tabindex", "-1");
      $("main, footer").show(0);
      $("header, .js-nav").scrollTop(0);
      $(".js-search-btn").show();
    }
  })

  $(document).ready(function () {
    $('#yxt-SearchBar-input--search-bar').attr('role', 'combobox');
    $('#yxt-SearchBar-input--search-bar').attr('aria-activedescendant', '');
  });
}
export {
    init
}